export default __webpack_public_path__ + "static/media/art-brw-banner-2.cdc7e6fc.jpg";